import React from "react";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import currenciesService from "../../../services/currencies.service";
import FormModalContent from "./form";

const headerCells = [
  {
    field: "name",
    title: "نام",
    mainField: true,
  },
  {
    field: "code",
    title: "کد",
  },
  {
    field: "basePrice",
    title: "قیمت مبنا",
    currency: true,
  },
];

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
  {
    title: "کد",
    field: "code",
  },
];

export default function CurrenciesPage() {
  const deleteItem = (item) => {
    return currenciesService.deleteCurrency(item.id);
  };

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        backend={currenciesService.getCurrenciesUrl}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد ارز",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        searchKeys={defaultKeys}
        title="ارزها"
      />
    </div>
  );
}
